/* eslint-disable no-undef */
import { Box, Button, Grid2 as Grid, Radio, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import IntlMessages from "../../components/IntlMessages/IntlMessages";
import { UNModal } from "un-react-ui-components";

import { GRAY_BACKGROUND, GRAY_BLACK } from "../../themes/colors";
import Icon from "../../core/models/Icon";
import { useIconsActions } from "../../contexts/icons/UseIconsActions";
import { useIconsContext } from "../../contexts/icons/IconsContext";
import { capitalizeFirstLetter } from "../../util/utils";

type IconModalProps = {
  open: boolean;
  onClose(): void;
  onSave(icon: number): void;
};

const IconsModal = ({ open, onClose, onSave }: IconModalProps) => {
  const [loading, setLoading] = useState<boolean>(true);
  const { iconsResponseData } = useIconsContext();
  const { setSelectedIcon } = useIconsActions();
  const { selectedIcon } = useIconsContext();
  const handleSelect = (item: Icon) => {
    setSelectedIcon(item);
  };
  useEffect(() => {
    if (iconsResponseData && iconsResponseData.length > 0) {
      setLoading(false);
    }
  }, [iconsResponseData]);

  //#region Modal Actions
  const handeOnSave = () => {
    onSave(selectedIcon?.id || 0);
  };
  const onCancel = () => {
    onClose();
  };
  //#region end

  //#region Renderers
  const content = (
    <Box
      sx={{
        height: 400,
        overflow: "auto",
      }}
    >
      <Typography variant="body2" color={GRAY_BLACK} sx={{ marginBottom: 1 }}>
        <IntlMessages id="category.icon.modal.subtitle" />
      </Typography>

      <Box bgcolor={GRAY_BACKGROUND} sx={{ borderRadius: 2, p: 2 }}>
        <Grid container spacing={2}>
          {iconsResponseData?.map((item: Icon) => (
            <Grid size={{ xs: 6 }} key={"icon-" + item.id}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  padding: 1,
                  borderRadius: 2,
                  cursor: "pointer",
                }}
                bgcolor={"white"}
                onClick={() => handleSelect(item)} // Allow box click selection
              >
                <Radio
                  checked={selectedIcon?.id === item.id}
                  onChange={() => handleSelect(item)}
                  value={item.name}
                  color="info"
                />
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                    backgroundImage: `url(${item.icon})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                />
                <Typography variant="body1" color={GRAY_BLACK}>
                  {capitalizeFirstLetter(item.name).replaceAll("_", " ")}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );

  const actions = (
    <>
      <Typography>
        <span></span>
      </Typography>
      <Box className="flex space-x-[1.375rem]">
        <Button
          data-testid="icon.modal.cancel"
          variant="text"
          color="error"
          onClick={onCancel}
        >
          <IntlMessages id="cancel" />
        </Button>
        <Button data-testid="icon.modal.save" onClick={handeOnSave}>
          <IntlMessages id="save" />
        </Button>
      </Box>
    </>
  );
  //#endregion

  return (
    <UNModal
      id="categoryIconsModal"
      titleTranslationKey="category.icon.modal.title"
      showTitleBorder={false}
      open={open}
      loading={loading}
      onClose={() => onClose()}
      actions={actions}
      maxWidth="md"
    >
      {content}
    </UNModal>
  );
};

export { IconsModal };
